export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/provider-tax.abdf98ef-c1e1aa.svg";